import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { DropdownItem } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "../common/GenericModal";
import UpdatePasswordForm from "../forms/UpdatePasswordForm";
import UpdatePINForm from "../forms/UpdatePINForm";

const MainNavBarCredentialsLinks: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { isNativeApp } = rootStore.commonStore;
  const { isChangePwdOpen, setIsChangePwdOpen } = rootStore.userStore;
  const { isChangePINOpen, setIsChangePINOpen } = rootStore.offlineStore;
  const [t] = useTranslation(["translation", "nativeapp"], translationHookOptions);

  return (
    <>
      <DropdownItem onClick={() => setIsChangePwdOpen(true)}>
      {t("navbar_dropdown_change_pwd")}
      </DropdownItem>
      {isNativeApp && (
        <DropdownItem onClick={() => setIsChangePINOpen(true)}>
          {t("navbar_dropdown_change_offline_pin", { ns: "nativeapp"})}
        </DropdownItem>
      )}
      <DropdownItem divider />
      <GenericModal
        isOpen={isChangePwdOpen}
        toggle={() => setIsChangePwdOpen(false)}
        title={t("change_pwd_modal_title")}
        content={<UpdatePasswordForm />}
        actions={[]}
        size="md"
      />
      <GenericModal
        isOpen={isChangePINOpen}
        toggle={() => setIsChangePINOpen(false)}
        title={t("change_offline_pin_modal_title", { ns: "nativeapp"})}
        content={<UpdatePINForm />}
        actions={[]}
        size="md"
      />
    </>
  );
};

export default observer(MainNavBarCredentialsLinks);
